import numeral from "numeral";
import { IMAGES } from "../../assets/media/images";
import "./StatsHeader.scss";
import TimeLeftTimer from "../helpers/TimeLeftTimer";

function StatsHeader({ user }) {
    return (
        <div className="stats-wrapper">
            <div className="stats-header">
                <div className="vl-container">
                    <span className="title">Крутки</span>
                    <div className="value-block">
                        <img src={IMAGES.card} alt="twist" />
                        <span className="value">{user.twists}</span>
                    </div>
                </div>

                <div className="vl-container">
                    <span className="title">Сезонные очки</span>
                    <div className="value-block">
                        <img src={IMAGES.pts} alt="pts" />
                        <span className="value">{numeral(user.pts).format("0.00a")} pts</span>
                    </div>
                </div>

                <div className="vl-container">
                    <span className="title">Осколки</span>
                    <div className="value-block">
                        <img src={IMAGES.shards} alt="shards" />
                        <span className="value">{numeral(user.shards).format("0.00a")}</span>
                    </div>
                </div>
            </div>

            <div className="duration">
                <img src={IMAGES.watch} alt="watch" />
                <span className="title">До следующей крутки:</span>
                <span className="timer"><TimeLeftTimer targetTime={user.last_twist} /></span>
            </div>
        </div>
    );
};

export default StatsHeader;